import React, { useEffect } from 'react';

import t from 'utils/translate';
import LabelWithInfo from 'modules/shared/components/label-with-info';
import SideBarProfilePicture from './side-bar-profile-picture';
import SideBarUserInfoFields from './side-bar-user-info-fields';
import SideBarUserDetails from './side-bar-user-details';
import Preloader from 'modules/shared/components/preloader';
import { useSelector } from 'react-redux';
import { selectDataLoaded, forceDataLoading } from '../stores/company-settings-slice-handler';

function SideBar() {
    const dataLoaded = useSelector(selectDataLoaded);

    useEffect(() => {
        if (!dataLoaded) {
            forceDataLoading();
        }
    }, []);

    const sideBarContent = () => {
        if (!dataLoaded) {
            return <Preloader />;
        }

        return (
            <>
                <div className="settings-section-title settings-sidebar-title">
                    <LabelWithInfo text={t('settings_my_account')} />
                </div>
                <SideBarProfilePicture />
                <SideBarUserInfoFields />
                <SideBarUserDetails />
            </>
        );
    };

    return (
        <aside className="settings-section settings-sidebar wcf-ui-side-bar" data-test-id="settings-sidebar">
            <div className="settings-page-title page-title">
                <LabelWithInfo text={t('settings_title')} />
            </div>
            {sideBarContent()}
        </aside>
    );
}

export default SideBar;
